import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	dateRangePicker: {
		color: `${ theme.other.colors.text.primary } !important`,

		"& label, & input, & button": {
			color: `${ theme.other.colors.text.primary } !important`
		},

		"& .MuiInputBase-root": {
			borderColor: `${ theme.other.colors.text.primary } !important`
		},

		"& fieldset": {
			borderColor: `${ theme.other.colors.text.primary } !important`

		}
	}

} ) );
